



















import Vue, { PropType } from 'vue';
import { RouteConfig } from 'vue-router';
import { mapGetters } from 'vuex';
import { siblingPath, siblingRoutes } from '@/helpers/routing';

// This component will render all sibling routes in a tab nav.
// - To set tab labels, add a `meta.label` property to the sibling route.
// - To hide a sibling route's tab, add a `meta.hidden = true` property to the sibling route.
// - Unauthorized routes will be hidden according to the Vuex state.
export default Vue.extend({
  name: 'TabbedNav',
  computed: {
    ...mapGetters(['isAuthorizedRoute', 'routeLabel']),
    availableSiblings(): RouteConfig[] {
      return siblingRoutes(this.$route).filter((r) => {
        if (r.meta?.hidden) return false;
        if (r.redirect) return false;
        if (!this.isAuthorizedRoute(r)) return false;

        // Ignore targets that include params
        if (r.path.match(/\/:/)) return false;

        return true;
      });
    },
    depth() {
      return this.$route.matched.length;
    },
  },
  methods: {
    isCurrent(route: RouteConfig) {
      return route.path === this.$route.path;
    },
    hasLabel(route: RouteConfig): boolean {
      return !!route.meta?.label;
    },
    linkTarget(route: RouteConfig): string {
      return siblingPath(route, this.$route)
    },
  },
});
